import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", { transform: "matrix(0.7661960124969482, 0, 0, 0.7661960124969482, 54.744125366210966, 30.08584213256836)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M 471.796 169.621 L 471.796 136.085 L 432.564 136.085 L 432.564 66.853 C 432.436 53.066 421.172 41.986 407.385 42.085 L 56.207 42.085 C 42.42 41.986 31.156 53.066 31.028 66.853 L 31.028 496.853 C 31.156 510.64 42.42 521.72 56.207 521.621 L 407.385 521.621 C 421.172 521.72 432.436 510.64 432.564 496.853 L 432.564 425.621 L 471.796 425.621 L 471.796 392.085 L 432.564 392.085 L 432.564 297.621 L 471.796 297.621 L 471.796 264.085 L 432.564 264.085 L 432.564 169.621 L 471.796 169.621 Z M 399.028 264.085 L 351.796 264.085 L 351.796 297.621 L 399.028 297.621 L 399.028 392.085 L 351.796 392.085 L 351.796 425.621 L 399.028 425.621 L 399.028 488.085 L 64.564 488.085 L 64.564 75.621 L 399.028 75.621 L 399.028 136.085 L 351.796 136.085 L 351.796 169.621 L 399.028 169.621 L 399.028 264.085 Z",
        class: "ci-primary",
        style: {"transform-box":"fill-box","transform-origin":"50% 50%"},
        transform: "matrix(-1, 0, 0, -1, -0.000018, -0.000048)"
      }),
      _createElementVNode("rect", {
        x: "85.259",
        y: "70.312",
        width: "36.496",
        height: "428.1",
        rx: "5",
        ry: "5",
        fill: "currentcolor"
      }),
      _createElementVNode("rect", {
        x: "164.356",
        y: "62.041",
        width: "293.085",
        height: "428.1",
        rx: "5",
        ry: "5",
        fill: "currentcolor"
      })
    ])
  ]))
}